export default __webpack_public_path__ + "images/a848366160d7a85627236c6f3538fe74.svg";